import {
  COMMON,
  type CommonProps,
  type FlexProps,
  type LayoutProps,
} from '#app/theme/constants.js';
import { FLEX, LAYOUT } from '#app/theme/index.js';
import { sx, type SXProps } from '#app/theme/utils.js';
import TextareaAutosize from 'react-textarea-autosize';
import { css, styled } from 'styled-components';

type StyledTextFieldTextAreaProps = CommonProps &
  FlexProps &
  LayoutProps &
  SXProps;

const minHeight = 54;

// 16px * 1.5
const rowHeight = 24;
const rowDifference = minHeight - rowHeight;

export const StyledTextFieldTextArea = styled(
  TextareaAutosize,
)<StyledTextFieldTextAreaProps>`
  ${({ rows, theme }) => css`
    flex: 1;
    /** 56px - 2px for border */
    min-height: ${rows
      ? `${rows * rowHeight + rowDifference}px`
      : `${minHeight}px`};
    padding: 8px 4px;
    margin: 0;
    outline: none;
    border: 0;
    background-color: transparent;
    border-radius: inherit;
    line-height: 1.5;
    resize: vertical;

    &:disabled {
      background: none;
      color: ${theme.colorsV2.gray40};

      &::placeholder {
        color: ${theme.colorsV2.gray40};
      }
    }

    &:focus {
      /* This is required because of the CSS reset */
      margin-left: 0;
      margin-right: 0;
      padding-left: 4px;
      padding-right: 4px;
    }

    &:first-child,
    &:first-child:focus {
      padding-left: 16px;
      margin-left: 0;
    }

    &:last-child,
    &:last-child:focus {
      padding-right: 16px;
      margin-right: 0;
    }

    &::placeholder {
      opacity: 1;
      color: ${theme.colorsV2.gray60};
    }
  `}

  ${COMMON}
  ${FLEX}
  ${LAYOUT}
  ${sx}
`;

StyledTextFieldTextArea.displayName = 'TextField.TextArea';
